import React, { useMemo } from 'react';
import { ListItem, ListItemText } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { SmartDiaryEntry } from '../type';
import { CustomCPTLabel } from './CustomCPTLabel';
import { LabelsTooltip } from './LabelsTooltip';

type SmartListItemProps = { smartEntry: SmartDiaryEntry };

const useStyles = makeStyles(() => ({
  listItem: {
    paddingTop: 0,
    paddingBottom: 0
  }
}));
export const SimpleListItem: React.FC<SmartListItemProps> = ({
  smartEntry
}: SmartListItemProps) => {
  const classes = useStyles();

  return (
    <ListItem className={classes.listItem}>
      <LabelsTooltip smartEntry={smartEntry}>
        <ListItemText
          data-testid={`smart-entry-item_cpt_${smartEntry.id}`}
          primary={useMemo(
            () => (
              <CustomCPTLabel smartEntry={smartEntry} />
            ),
            [smartEntry]
          )}
        />
      </LabelsTooltip>
    </ListItem>
  );
};
